import { IconButton, Tooltip } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { FunctionComponent, ReactNode } from 'react';

export interface IIconButtonCellRendererParams<T> {
  icon: ReactNode;
  callback: (rowData: T) => void;
  tooltip?: string;
}

export interface IIconButtonCellRendererProps extends ICellRendererParams, IIconButtonCellRendererParams<unknown> {}

const IconButtonCellRenderer: FunctionComponent<IIconButtonCellRendererProps> = (props) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (props.data) {
      props.callback(props.data);
    }
  };

  return (
    <Tooltip title={props.tooltip || ''}>
      <IconButton size="small" onClick={handleClick} className="p-1">
        {props.icon}
      </IconButton>
    </Tooltip>
  );
};

export default IconButtonCellRenderer;
